export default "__VITE_ASSET__2VchVpNa__"